import React from "react";
import OtpInput from "react-otp-input";
import './ReactOtpField.css';

export default function ReactOtpField(props) {
    const handleChange = (otp) => {
        props.handleOTP(otp)
    }

    return (
        <div className={props.parentClass}>
            <div className={`form-group class_otp ${props.class}`}>
                <label className="form-lable text-uppercase">{props.label}</label>
                <OtpInput
                    value={props.otp}
                    onChange={handleChange}
                    numInputs={props.numInputs ? props.numInputs : 4}
                    separator={<span style={{ display: 'inline-block' }}> &nbsp;  &nbsp;</span>}
                    shouldAutoFocus={props.shouldAutoFocus}
                    isInputSecure={props.isInputSecure}
                    isInputNum={true}
                />
            </div>
        </div>
    );

}
